import { render, staticRenderFns } from "./ListItemBase.vue?vue&type=template&id=71fb80d4&scoped=true&lang=pug&"
import script from "./ListItemBase.vue?vue&type=script&lang=ts&"
export * from "./ListItemBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb80d4",
  null
  
)

export default component.exports